import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const GetMadbValuesSchema = z.object({
  productNc: z.string().regex(/^[0-9]{6}$|^[0-9]{8}$/, 'Must be 6 or 8 numeric digits'),
  declarantIso: z.string().optional(),
  partnerIso: z.string().optional(),
});

export type GetMadbValuesCommand = z.infer<typeof GetMadbValuesSchema>;

export const MadbValueSchema = z.object({
  productNc: z.string(),
  valueInEuros: z.number(),
  quantityInKg: z.number(),
  value: z.number(),
});

export const GetMadbValuesResultSchema = z.array(MadbValueSchema);

export type GetMadbValuesResult = z.infer<typeof GetMadbValuesResultSchema>;

export const UpdateMadbSchema = z.object({
  fileURL: z.string().url(),
});

export type UpdateMadbCommand = z.infer<typeof UpdateMadbSchema>;

export const UpdateMadbResultSchema = z.boolean();

export const PublishMadbSchema = z.object({});

export const PublishMadbResultSchema = z.boolean();

export const CreateMadbIndexesSchema = z.object({});

export const MadbCreateIndexesResultSchema = z.object({
  status: z.string(),
});

export const madbContract = c.router({
  getMadbValues: {
    method: 'GET',
    path: '/external-api/madb-values',
    query: GetMadbValuesSchema,
    responses: { 200: GetMadbValuesResultSchema },
  },
  updateMadb: {
    method: 'POST',
    path: '/external-api/update-madb',
    body: UpdateMadbSchema,
    responses: { 200: UpdateMadbResultSchema },
  },
  publishMadb: {
    method: 'POST',
    path: '/external-api/publish-madb',
    body: c.noBody(),
    responses: { 200: PublishMadbResultSchema },
  },
  createMadbIndexes: {
    method: 'GET',
    path: '/external-api/madb-create-indexes',
    responses: { 200: MadbCreateIndexesResultSchema },
  },
});
